"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.incrementYearsInText = void 0;
const YEAR_PATTERN = /\b(19\d{2}|20\d{2})(?:([-/])(\d{2}|\d{4}))?\b/g;
const incrementShortOrFullYear = (year) => {
    const incremented = Number(year) + 1;
    return year.length === 2 ? String(incremented % 100).padStart(2, "0") : String(incremented);
};
const incrementYearsInText = (text) => text.replace(YEAR_PATTERN, (_match, year, separator, secondYear) => separator && secondYear
    ? `${incrementShortOrFullYear(year)}${separator}${incrementShortOrFullYear(secondYear)}`
    : incrementShortOrFullYear(year));
exports.incrementYearsInText = incrementYearsInText;
